import matchHeight from "jquery-match-height";
import 'slick-carousel';


var $el = $('.slick-slider');

$el.on('init', function(slick) {
    $el.find('.slick-cloned:first-child').addClass('on');
    $el.find('.box').matchHeight({
        byRow: false,
        property: 'height',
        target: null,
        remove: false
    });
});

$el.slick({
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 3,
	speed: 1000,
	dots: true,
	arrows: false,
}).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
	console.log(nextSlide);
    if (currentSlide !== nextSlide) {
        $('.slick-active + .slick-cloned').each(function(index, el) {
        	var $this = $(this);
        	setTimeout(function() {
        		$this.addClass('slick-current').addClass('slick-active');
	        	$this.next().addClass('slick-active');
	        	$this.next().next().addClass('slick-active');
        	})
        });
    }
});